//
import { ModuleLayout } from '@/components/reusable_components/next'
import ItemList from '@/views/Item/ItemList'
import { CreateItemStepper } from '@/views/Item'
import {
    ProductsSalePriceList,
    ProductsSalePriceMarginList,
} from '@/views/Products'
import ProductShowEditTabs from '@/views/Item/ShowEditTabs'
import ProductsWholesaleDiscountsCreate from '@/views/Products/ProductsWholesaleDiscounts/ProductsWholesaleDiscountsCreate'
import ProductsWholesaleDiscountsShowEdit from '@/views/Products/ProductsWholesaleDiscounts/ProductsWholesaleDiscountsShowEdit'
import CreateMainProductTab from '../../views/Item/newTabProduct/create/CreateMain.vue'
import ShowEditMainProductAux from '../../views/Item/newTabProduct/showEdit/ShowEditMain.vue'
import NewProductSalePrice from '@/views/Products/newProductSalePrice/NewProducSalePrice.vue'
//
export default {
    path: 'products',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'products_list',
            component: ItemList,
        },
        // {
        //     path: 'create',
        //     name: 'products_create',
        //     component: CreateItemStepper,
        //     meta: {
        //         title: 'Crear producto',
        //     },
        // },
        {
            path: 'create',
            name: 'products_create',
            component: CreateMainProductTab,
            meta: {
                title: 'Crear producto',
            },
        },
        {
            path: 'sale_price',
            name: 'products_sale_price',
            component: NewProductSalePrice,
            meta: {
                title: 'Modificar precios de venta',
            },
        },
        {
            path: 'sale_price_margin',
            name: 'products_sale_price_margin',
            component: ProductsSalePriceMarginList,
            meta: {
                title: 'Modificar margen de venta',
            },
        },
        {
            path: ':id',
            name: 'products_show',
            component: ShowEditMainProductAux,
            meta: {
                title: 'Detalles del producto',
            },
        },
        {
            path: 'old/:id',
            name: 'products_show',
            component: ProductShowEditTabs,
            meta: {
                title: 'Detalles del producto',
            },
        },
        {
            path: ':id/wholesale_discounts',
            name: 'products_wholesale_discounts',
            component: ProductsWholesaleDiscountsShowEdit,
            meta: {
                title: 'Modificar descuento del producto',
            },
        },
        {
            path: ':id/wholesale_discounts/create',
            name: 'products_wholesale_discounts_create',
            component: ProductsWholesaleDiscountsCreate,
            meta: {
                title: 'Crear descuento del producto',
            },
        },
    ],
    meta: {
        title: 'Productos',
    },
}

